import React from "react";
import { Link } from "gatsby";

import useWindowDimensions from "../../hooks/useWindowDimensions";

import ICONS from "../../constants/icons";
import { socialButtons } from "../../constants/enums";

import { Icon } from "../../components";
import { IconButton } from "../../components/buttons";
import ICON_SIZE from "../../components/icon/enums";

const ContactUs = () => {
  const { isSmallScreen } = useWindowDimensions();
  const handleSocialIconsClick = (path: string) => {
    window.open(path, "_blank");
  };

  return (
    <div className={`m-contact__right ${isSmallScreen ? "fullWidth" : ""}`}>
      <h1>Contact us</h1>
      <div className="-mt20">
        <p className="text-white">
          Questions, comments, or suggestions? Simply fill in the form and we’ll
          be in touch shortly.
        </p>
      </div>
      <div className="column -row-gap15 -mt30">
        <span className="m-footer__links aligned-start text-white -column-gap10">
          <Icon name={ICONS.LOCATION} />
          <div className="column">
            <span>Einsiedlerstrasse 15b</span>
            <span> 8834 Schindellegi</span>
            <span> Switzerland</span>
          </div>
        </span>
        <Link
          className="m-footer__links -menu aligned-center text-white -column-gap10"
          to="#"
          onClick={(e) => {
            e.preventDefault();
            window.open(`tel:${+12242765400}`);
          }}
        >
          <Icon name={ICONS.PHONE} size={24} />
          <p className="text-white"> +12242765400</p>
        </Link>
        <Link
          className="m-footer__links -menu aligned-center text-white -column-gap10"
          to="#"
          onClick={(e) => {
            e.preventDefault();
            window.open("mailto:info@skillndepth.com");
          }}
        >
          <Icon name={ICONS.EMAIL} />
          <p className="text-white">info@skillndepth.com</p>
        </Link>

        <Link
          to="https://skillndepth.com/"
          target="_blank"
          className="m-footer__links -menu aligned-center text-white -column-gap10"
        >
          <Icon name={ICONS.LINK} />
          <p className="text-white">skillndepth.com</p>
        </Link>
      </div>
      <div className="-column-gap20 aligned-start">
        <div className="column aligned-start">
          <h3>Socials</h3>
          <div className="aligned-center -column-gap20">
            {socialButtons.map(({ id, iconName, path }) => (
              <IconButton
                key={id}
                handleClick={() => handleSocialIconsClick(path)}
                name={iconName}
                size={ICON_SIZE.SIZE_20}
                socialButton
                aria={{
                  label: iconName,
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
